module.exports = __webpack_public_path__ + "img/welfare-permanentactivitytemp.5dd9da7b.png";